var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconApprovedGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2Z",
    fill: "#237B4B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94686 15.7559L7.222 12.7595C7.07987 12.6036 7 12.3919 7 12.1711C7 11.9503 7.07987 11.7386 7.222 11.5827C7.51802 11.2572 7.9962 11.2572 8.29221 11.5827L10.4858 13.9864L15.7078 8.24413C16.0038 7.91862 16.482 7.91862 16.778 8.24413C17.074 8.56964 17.074 9.09546 16.778 9.42097L11.0171 15.7559C10.7286 16.0814 10.2429 16.0814 9.94686 15.7559Z",
    fill: "#E7F2DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconApprovedGreen);
export default __webpack_public_path__ + "static/media/Icon_Approved_Green.b77a4d8f84566ce32cdf4e5f614b51c0.svg";
export { ForwardRef as ReactComponent };